module.exports = __webpack_public_path__ + "static/media/photo23.d74ea750.jpg";